// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCardStyles } from "@tps/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { css } from "styled-components";

productGridCardStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        height: 100%;
        overflow: hidden;
        > :last-child {
            max-width: calc(100% - 80px);
        }
    `,
};

productGridCardStyles.imageWrapper = {
    css: css`
        max-width: 80px;
        flex-basis: 80px;
        flex-shrink: 0;
    `,
};
